const env = process.env.NODE_ENV
export const getEnv = () => { return env } // Get the build env
export const isDev = () => { return getEnv() === 'development' } // Development build
export const isProductionHost = () => {
    return window.location.hostname === 'oma.nettix.fi' || window.location.hostname === 'oma.almaajo.fi'
}
export const isStagingHost = () => { return window.location.hostname === 'oma.almaajo.dev' }
